//@flow
import React from 'react';
import Constants from '../../constants';

type Props = {
  resetEmail:string,
  showSignIn:() => void,
};

export default function ResetEmailSent(props:Props) {
  return (
    <div className="reset-container">
      <h2 className="reset-header">Email sent</h2>
      <div className="reset-subheader">A sign in link was emailed to <span className="bold">{props.resetEmail}</span>. Please use the link to reset your password.</div>
      <div className="contact-us">Not sure if it&apos;s the correct email? <a className="link-small" href={Constants.SUPPORT_LINK}>Contact us</a></div>
      <div className="back-to-signin" onClick={props.showSignIn}>Back to sign in</div>
    </div>
  );
}
